<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="icn_alert">
<path id="Compound_Path" fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM9.21448 4.28558H10.7859V12.1427H9.21448V4.28558ZM8.92883 15.357C8.92883 15.9284 9.42883 16.4284 10.0003 16.4284C10.5717 16.4284 11.0717 15.9284 11.0717 15.357C11.0717 14.7856 10.5717 14.2856 10.0003 14.2856C9.42883 14.2856 8.92883 14.7856 8.92883 15.357Z" fill="#E4315F"/>
</g>
</svg>
